import React from 'react';

const Logo = ({ size = 'md', className = '' }) => {
  const sizeConfig = {
    sm: { text: 'text-xl' },
    md: { text: 'text-3xl' },
    lg: { text: 'text-4xl' },
    xl: { text: 'text-5xl' }
  };

  const config = sizeConfig[size] || sizeConfig.md;

  return (
    <div className={className}>
      <span className={`${config.text} font-playfair font-bold gradient-text`}>
        wako
      </span>
    </div>
  );
};

export default Logo;
